import type {
  AnalyticsEnvironment,
  PageData,
  SubscriberStatus,
  UserData
} from "./types";

const SUBSCRIPTION_COOKIE = "@Cobasi+:subscriptionData";

export const getCookie = (name: string): string | undefined => {
  if (typeof document === "undefined") return undefined;

  const encodedName = encodeURIComponent(name);
  const match = document.cookie
    .split("; ")
    .find(
      (row) => row.startsWith(`${name}=`) || row.startsWith(`${encodedName}=`)
    );

  if (!match) return undefined;

  const value = match.slice(match.indexOf("=") + 1);
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const getAnalyticsEnvironment = (
  hostname = typeof window !== "undefined" ? window.location.hostname : ""
): AnalyticsEnvironment => {
  if (hostname === "www.cobasi.com.br" || hostname === "cobasi.com.br") {
    return "production";
  }

  return "homolog";
};

export const normalizePagePath = (path: string): string => {
  const cleanPath = path
    .split("?")[0]
    .split("#")[0]
    .replace(/^\/+|\/+$/g, "");

  return cleanPath || "homepage";
};

const normalizeSubscriber = (value?: string): SubscriberStatus | null => {
  if (!value) return null;

  const normalized = value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

  if (normalized.includes("usuario nao identificado")) {
    return "Usuario nao identificado";
  }

  if (normalized === "nao assinante" || normalized.includes("nao assinante")) {
    return "Nao assinante";
  }

  if (normalized.includes("assinante")) {
    return "Assinante";
  }

  return null;
};

export const getAnalyticsUserData = (): UserData => {
  const userId = getCookie("userId") || "";
  const isLoggedIn = Boolean(
    getCookie("cobasiSession") || getCookie("VtexIdclientAutCookie_cobasi")
  );

  if (!isLoggedIn) {
    return {
      user_id: userId,
      is_logged_in: "no",
      subscriber: "Usuario nao identificado"
    };
  }

  const subscriberFromCookie = normalizeSubscriber(
    getCookie(SUBSCRIPTION_COOKIE)
  );

  return {
    user_id: userId,
    is_logged_in: "yes",
    subscriber: subscriberFromCookie || "Nao assinante"
  };
};

export const buildCurrentPageData = (
  path = typeof window !== "undefined" ? window.location.pathname : "/"
): PageData => {
  const pagePath = normalizePagePath(path);

  return {
    environment: getAnalyticsEnvironment(),
    page_name: `cobasi::${pagePath}`,
    page_category_level_1: "cobasi",
    page_category_level_2: pagePath,
    page_category_level_3: ""
  };
};
